export enum NetworkType {
  NETWORK_TYPE_WIFI = 'NETWORK_TYPE_WIFI',
  NETWORK_TYPE_CELLULAR = 'NETWORK_TYPE_CELLULAR',
}
